import React from 'react';
import styles from './BranchSelector.scss';
import BranchSelectorMap from './BranchSelectorMap';
import ModalLayout from '../ModalLayout/ModalLayout';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import BranchList from './BranchList';
import { array, bool, func, object, string } from 'prop-types';
import { convertOrganizationToBranch } from '../../utils/BranchUtils';
import _ from 'lodash';
import { BranchSelectorGMap } from '../Maps/BranchSelectorGMap';
import { Modal } from 'wix-style-react';

const FAKE_BRANCH = {
  title: '.',
  address: '.',
  formattedDistance: '..............',
  deliveryTypes: ['..............'],
};

export default class BranchSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      selectedBranchIndex: 1,
    };
  }

  handleOkClick = () => {
    const { onSubmit, isSubmitButtonLoading } = this.props;

    if (!isSubmitButtonLoading) {
      onSubmit({ branchId: this._getValue() });
    }
  };

  handleChange = value => {
    const selectedBranchIndex = this.state.branches.findIndex(branch => branch.id === value);
    this.setState({ value, selectedBranchIndex });
  };

  static getDerivedStateFromProps(props) {
    const branches = _.chain(props.organizations)
      .map(branch =>
        convertOrganizationToBranch({
          organization: branch,
          deliveryString: 'Delivery',
          takeoutString: 'Takeout',
          baseLocation: props.baseLocation,
        }),
      )
      .sortBy(branch => branch.distance)
      .value();

    return { branches };
  }

  static renderLoader() {
    return (
      <BranchList
        data-hook="branch-selector-loading"
        branches={[FAKE_BRANCH, FAKE_BRANCH, FAKE_BRANCH, FAKE_BRANCH]}
        isLoading
      />
    );
  }

  render() {
    const { onCancel, isListLoading, isSubmitButtonLoading, isOpen } = this.props;
    const { branches } = this.state;
    const value = this._getValue();
    const footer = (
      <BasicModalLayoutFooter
        onCancelClick={onCancel}
        onOkClick={this.handleOkClick}
        data-hook="branch-selector-footer"
        disabled={!value}
        okLoading={isSubmitButtonLoading}
      />
    );

    return (
      <Modal isOpen={isOpen}>
        <ModalLayout size="large" showCloseIcon={false} title="Select Branch" footer={footer} scrollable={false}>
          <div className={styles.wrapper}>
            <BranchSelectorMap>
              <div className={styles.branches}>
                {isListLoading ? (
                  BranchSelector.renderLoader()
                ) : (
                  <BranchList branches={branches} value={value} onChange={this.handleChange} />
                )}
              </div>
              <BranchSelectorGMap
                onSelectBranch={this.handleChange}
                branches={branches}
                selectedBranch={this.state.selectedBranchIndex}
                customerLocation={{ lat: 34.0670629, lng: -118.4012643 }} //todo masha remove hard coded
              />
            </BranchSelectorMap>
          </div>
        </ModalLayout>
      </Modal>
    );
  }

  _getValue() {
    const { initialValue } = this.props;
    const { value } = this.state;
    return value || initialValue;
  }
}

BranchSelector.displayName = 'BranchSelector';
BranchSelector.propTypes = {
  organizations: array,
  onCancel: func,
  onSubmit: func,
  baseLocation: object,
  isListLoading: bool,
  isSubmitButtonLoading: bool,
  initialValue: string,
  isOpen: bool,
};
BranchSelector.defaultProps = {
  branches: [],
};
